import type { RootState } from '../reducers/rootReducer.ts';

const users = (state: RootState) => state.userManagementReducer.users;
const userById = (id: number) => (state: RootState) => state.userManagementReducer.users.find((u) => u.id === id);
const usersLoaded = (state: RootState) => state.userManagementReducer.usersLoaded;
const usersTotal = (state: RootState) => state.userManagementReducer.users.length;
const invitations = (state: RootState) => state.userManagementReducer.invitations;

export { users, userById, usersLoaded, usersTotal, invitations };
